module.exports = __webpack_public_path__ + "img/5.52ccee15.png";